import { Component, OnInit } from '@angular/core';
import { ChildrenMenu } from 'src/app/models/children-menu';
import { ParentMenu } from 'src/app/models/parent-menu';
import { AuthService } from 'src/app/services/auth/auth.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.css']
})
export class ContainerComponent implements OnInit {
  parent_menu: ParentMenu[] = [];
  children_menu: ChildrenMenu[] = [];

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.loadMenu();
  }

  loadMenu() {
    let menus = this.authService.getMenu();
    if (menus.length > 0) {
      menus.forEach(menu => {
        this.parent_menu.findIndex(pm => pm.ID_PARENT == menu.ID_PARENT) == -1 ?
          this.parent_menu.push({ ID_PARENT: menu.ID_PARENT, PARENT: menu.PARENT, ICON: menu.ICON }) :
          null;
      });
      menus.forEach(menu => {
        this.children_menu.findIndex(cm => cm.ID_MENU == menu.ID_MENU) == -1 ?
          this.children_menu.push({ ID_MENU: menu.ID_MENU, MENU: menu.MENU, URL: menu.URL, ICONO: menu.ICONO, POS: menu.POS }) :
          null;
      })
      // console.log(this.parent_menu);
      // console.log(this.children_menu);
      this.children_menu = this.children_menu.sort((a,b) => a.MENU.localeCompare(b.MENU));
    }
  }

  hasChildren(parent: ParentMenu) {
    return this.children_menu.findIndex(cm => cm.POS == parent.ID_PARENT) != -1 ? true : false;
  }
  vermanual() {
    let url = "/assets/manual.pdf";
    let link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.click();
    window.URL.revokeObjectURL(url);
}

  cerrarSesion() {
    this.authService.logout();
  }
  public get USERNAME (){
    return `${this.authService.getUserSessionData('NOMBRES')} ${this.authService.getUserSessionData('AP_PATERNO')} ${this.authService.getUserSessionData('AP_MATERNO')}`
  }
}
